import { sortResults, sortCollection } from '@/utils/collections'

import { Module } from 'vuex'
import axios from '../plugins/axios'

const teamMemberModule: Module<any, any> = {
    state: {
        filters: {},
    },
    actions: {
        async initMemberIndex(state: any) {
        	if (this.memberIndexLoading) {
        		await this.initMemberPromise
        		return
        	}
            this.memberIndexLoading = true
            this.initMemberPromise = this.dispatch('initIndex', {
                id: 'member',
                idField: 'id',
                indexedFields: [
                    'name',
                    'firstName',
                    'lastName',
                    'username',
                ],
                source: '/api/workspace_members',
                store: [
                    '@id',
                    '@type',
                    'active',
                    'activeNetworks',
                    'createdAt',
                    'delegatedSeatNetwork',
                    'delegatedSeatType',
                    'deleted',
                    'deletedOn',
                    'id',
                    'isDelegatedSeat',
                    'lastPostedAt',
                    'locked',
                    'managedWorkspaceMembers',
                    'managingWorkspaceMembers',
                    'mediaPoints',
                    'name',
                    'firstName',
                    'lastName',
                    'phoneNumber',
                    'jobTitle',
                    'jobFunction',
                    'jobFunctions',
                    'jobDescription',
                    'strategy',
                    'country',
                    'timezone',
                    'personalUrl',
                    'rank',
                    'rejected',
                    'reviewed',
                    'roles',
                    'stats',
                    'status',
                    'tags',
                    'topics',
                    'type',
                    'extensionInstalled',
                    'unsubscribedAt',
                    'updatedAt',
                    'username',
                    'autoPilot',
                    'toneOfVoices',
                    'profileImage',
                ],
            })
            await this.initMemberPromise
            this.memberIndexLoading = false
            this.initMemberPromise = null
        },

        async getMembers(_, params) {
            let records = null

            const indexExists = await this.dispatch('indexExists', 'member')

            // skipIndex: callers that always query the backend (e.g. /reporting/members) don't need the local index
            if (!indexExists && !params?.skipIndex) {
                await this.dispatch('initMemberIndex')
            }

            const backendFiltersPresent =
                params?.filters?.fromDate ||
                params?.filters?.toDate ||
                (params?.filters?.network && params?.filters?.network !== 'extension') ||
                params?.filters?.sharedContent ||
                params?.filters?.managersOf

            if (
                backendFiltersPresent ||
                params?.refresh ||
                params?.filters?.status !== 'active'
            ) {
                const page = 'page=' + (params?.page ?? 1)
                const perPage = params?.perPage
                    ? '&itemPerPage=' + params.perPage
                    : ''
                const search = params?.search ? '&search=' + params.search : ''
                const username = params?.username ? '&username=' + params.username : ''
                const statusFilter = params?.filters?.status
                    ? '&status=' + params.filters.status
                    : ''
                const tagFilter = params?.filters?.tag
                    ? '&workspaceMemberTag=' + params.filters.tag
                    : ''
                const multipleTagsFilter = params?.filters?.tags?.length > 0
                    ? '&workspaceMemberTags=' + params.filters.tags
                    : ''
                const topicFilter = params?.filters?.topic
                    ? '&topic=' + params.filters.topic
                    : ''
                const multipleTopicsFilter = params?.filters?.topics?.length > 0
                    ? '&topics=' + params.filters.topics
                    : ''
                const roleFilter = params?.filters?.role
                    ? '&role=' + params.filters.role
                    : ''
                const fromDateFilter = params?.filters?.fromDate
                    ? '&statsDate[from]=' + params.filters.fromDate
                    : ''
                const toDateFilter = params?.filters?.toDate
                    ? '&statsDate[to]=' + params.filters.toDate
                    : ''
                const networkFilter = params?.filters?.network
                    ? '&network=' + params.filters.network + '&valid=' + !!(params?.filters?.valid)
                    : ''
                const sharedContentFilter = params?.filters?.sharedContent
                    ? '&sharedContent=' + params.filters.sharedContent
                    : ''
                const managersOfFilter = params?.filters?.managersOf
                    ? '&managersOf=' + params.filters.managersOf
                    : ''
                const managedByFilter = params?.filters?.managedBy
                    ? '&managedBy=' + params.filters.managedBy
                    : ''
                const seatTypeFilter = params?.filters?.seatType
                    ? '&seatType=' + params.filters.seatType
                    : ''
                const statsFilter = params?.filters?.statsFilter
                    ? '&statsFilter=' + params.filters.statsFilter
                    : ''
                const postToNetworks = params?.filters?.postToNetworks ? '&postToNetworks=' + params?.filters.postToNetworks : ''
                const workspaceMemberIds = params?.workspaceMemberIds
                    ? '&workspaceMemberIds=' + params.workspaceMemberIds
                    : ''    
                const startDate = params?.start
                    ? '&statsDate[from]=' + params.start
                    : ''  
                const endDate = params?.end
                    ? '&statsDate[to]=' + params.end
                    : ''     
                const hasContents = params?.hasContents ? '&hasContents=' + params?.hasContents : ''
                const showDeleted = params?.showDeleted ? '&showDeleted=' + params?.showDeleted : ''
                const memberReport = params?.filters?.memberReport ? '&memberReport=1' : ''

                const sortBy = params?.sortBy ? '&sort=' + params.sortBy : ''
                const sortOrder = params?.sortOrder
                    ? '&order=' + params.sortOrder
					: ''    

                const { data } = await axios.get(
                    '/api/workspace_members?' +
                    page +
                    perPage +
                    search +
                    username + 
                    statusFilter +
                    tagFilter +
                    multipleTagsFilter +
                    topicFilter +
                    multipleTopicsFilter +
                    roleFilter +
                    fromDateFilter +
                    toDateFilter +
                    networkFilter +
                    sharedContentFilter +
                    managersOfFilter +
                    managedByFilter +
                    seatTypeFilter +
                    statsFilter +
                    postToNetworks +
                    workspaceMemberIds +
                    startDate +
                    endDate +
                    hasContents + 
                    showDeleted +
                    memberReport +
                    sortBy +
                    sortOrder,
                )

                records = {
                    items: data['hydra:member'],
                    count: data['hydra:totalItems'],
                }
            } else {
                const statusFilter = (items) => {
                    const filter = params?.filters?.status
                    return filter
                        ? items?.filter((e) => e.status === filter)
                        : items
                }

                const extensionFilter = (items) => {
                    const filterValue = params?.filters?.network
                    // Filter and return items where chromeExtensionInstalled is true
                    if(filterValue === 'extension'){
                        const newData = items
                        .filter((item) => item.extensionInstalled)

                    return  newData
                    } else {
                        return items
                    }
                }

                const memberIdsFilter = (items) => {
                    const filter = params?.filters?.workspaceMemberIds
                    return filter
                        ? items?.filter((e) => filter.find((m) => parseInt(m) === e.id))
                        : items
                }

                const roleFilter = (items) => {                    
                    const filter = params?.filters?.seatType ?? params?.filters?.role                    
                    return filter && filter === 'page'
                        ? items?.filter((e) => e?.isDelegatedSeat)
                        : filter && filter === 'people'
                        ? items?.filter((e) => !e?.isDelegatedSeat)
                        : filter && filter !== 'page'
                        ? items?.filter((e) => e?.roles?.find((role) => role === filter))
                        : items
                }

                const topicFilter = (items) => {
                    const filter = params?.filters?.topics
                    return filter && filter?.length > 0
                        ? items?.filter((e) => e.topics.filter((t) => filter.includes(t))?.length > 0)
                        : items
                }

                const tagFilter = (items) => {
                    const filter = params?.filters?.tag
                    return filter
                        ? items?.filter((e) => e.tags.some(tag => filter.includes(tag)))
                        : items
                }

                const tagsFilter = (items) => {
                    const filter = params?.filters?.tags
                    return filter && filter?.length > 0
                        ? items?.filter((e) => e.tags.filter((t) => filter.includes(t))?.length > 0)
                        : items
                }

                const processRankByGroup = (items) => {
                    if (params?.rankByGroup) {
                        const filteredItems = memberIdsFilter(items)
                        sortResults(filteredItems, 'mediaPoints', 'desc')
                        filteredItems.forEach((item, index) => {
                            item.rankByGroup = index + 1
                        })
                    }     
                    return items
                }

                const sortName = (items) => {
                    return sortCollection(items, 'name', params?.sortOrder?.toLowerCase() === 'asc')
                }

                const sortType = (items) => {
                    return sortResults(items, 'type', params?.sortOrder)
                }

                const sortRank = (items) => {
                    return sortResults(items, 'rank', params?.sortOrder)
                }

                const sortRankByGroup = (items) => {             
                    return sortResults(items, 'rankByGroup', params?.sortOrder)
                }
            
                const sortComments = (items) => {                    
                    return sortCollection(items, 'stats.comments', params?.sortOrder?.toLowerCase() === 'asc')
                }
            
                const sortPosts = (items) => {                    
                    return sortCollection(items, 'stats.posts', params?.sortOrder?.toLowerCase() === 'asc')
                }
            
                const sortEngagements = (items) => {
                    return items?.sort((a, b) =>
                a?.stats.likes + a?.stats.comments + a?.stats.reshares < b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? -1 : 1
                    : a?.stats.likes + a?.stats.comments + a?.stats.reshares > b?.stats.likes + b?.stats.comments + b?.stats.reshares
                        ? params?.sortOrder?.toLowerCase() === 'asc' ? 1 : -1
                        : 0,
                    )
                }

                const sortMediaPoints = (items) => {
                    return sortResults(items, 'mediaPoints', params?.sortOrder)
                }

                const getSortOrder = () => {
                    if (params?.sortBy === 'type') {
                        return sortType
                    } else if (params?.sortBy === 'rank') {
                        return sortRank
                    } else if (params?.sortBy === 'rankByGroup') {
                        return sortRankByGroup
                    } else if (params?.sortBy === 'comments') {
                        return sortComments
                    } else if (params?.sortBy === 'posts') {
                        return sortPosts
                    } else if (params?.sortBy === 'engagements') {
                        return sortEngagements
                    } else if (params?.sortBy === 'mediaPoints') {
                        return sortMediaPoints
                    } else {
                        return sortName
                    }
                }

                records = await this.dispatch('getRecords', {
                    index: 'member',
                    term: params?.search,
                    fields: ['name', 'firstName', 'lastName', 'username'],
                    page: params?.page,
                    perPage: params?.perPage,
                    processes: [processRankByGroup],
                    filters: [extensionFilter, statusFilter, memberIdsFilter, roleFilter, topicFilter, tagFilter, tagsFilter].concat(
                        params.customFilters ?? [],
                    ),
                    sort: getSortOrder(),
                })
            }

            return records
        },

        async getAuthenticatedMember({ dispatch, state, getters}, id) {
            return getters.authedMemberInfo?.id ? dispatch('getMember', getters.authedMemberInfo.id) : null
        },

        async getMember(_, id) {
            if (id === undefined || id === null || id < 0) {
                throw new Error(`Invalid member ID specified: ${id}`)
            }
            
            const indexExists = await this.dispatch('indexExists', 'member')

            if (indexExists) {
                const record = await this.dispatch('getRecord', {
                    index: 'member',
                    id,
                });
                if(!record) {
                    return await this.dispatch('getMemberFresh', id)
                }
                return record;
            } else {
                return await this.dispatch('getMemberFresh', id)
            }
        },

        async getMemberFresh(_, id) {

            if (id === undefined || id === null || id < 0) {
                throw new Error(`Invalid member ID specified: ${id}`)
            }

            const { data } = await axios.get(`/api/workspace_members/${id}`, {
                cache: { override: true },
            })

            if (data) {
                if (await this.dispatch('indexExists', 'member')) {
                    await this.dispatch('addMemberRecord', data)
                } else {
                    // Building the index downloads every workspace member, so don't make the caller wait for it
                    this.dispatch('addMemberRecord', data).catch((e) => console.log(e))
                }
            }

            return data
        },

        async sendInvite(_, params) {
            await axios.post('/api/invitations', params)
        },

        async promote(_, params) {
            await axios.put(`/api/workspace_members/${params.id}/promote`, params)
        },

        async deleteInvite(_, inviteId) {
            await axios.delete(`/api/invitations/${inviteId}`)
        },

        async resendInvite(_, inviteId) {
            await axios.put('/api/invitations/' + inviteId + '/resend', {})
        },

        async sendExtensionInvite(_, id) {
            const { data } = await axios.put('/api/workspace_members/' + id + '/extensioninvite', {})

            return data
        },

        async getInvites(_, params) {
            const sortBy = params?.sortBy ? '&sort=' + params.sortBy : ''
            const sortOrder = params?.sortOrder
                ? '&order=' + params.sortOrder
                : ''    
            const url =
                '/api/invitations?page=' + params.page + '&itemPerPage=' + params.perPage + sortBy + sortOrder

            const { data } = await axios.get(url)
            return data
        },

        async reviewMember(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/review`,
                { 
                    reviewed: true,
                    rejected: params.rejected
                },
            )

            return data
        },

        async unsubscribeMember(_, { id }) {
            const { data } = await axios.put(
                `/api/workspace_members/${id}/unsubscribe`,
                {},
            )

            return data
        },

        async reSubscribeMember(_, { id }) {
            const { data } = await axios.put(
                `/api/workspace_members/${id}/resubscribe`,
                {
                },
            )

            return data
        },

        async unsubscribeMemberEmails(_, { id, username }) {
            const { data } = await axios.put(
                '/api/workspace_members/unsubscribe_emails',
                { id, username, unsubscribeEmail: true },
            )

            return data
        },

        async updateMemberPersonalInfo({ commit }, param) {
            const { data } = await axios.put(
                `/api/workspace_members/${param.id}`,
                param,
            )
			this.dispatch('addMemberRecord', data)
            return data
        },

        // My Network's job functions and seniority levels, for a member's job details
        async getJobOptions() {
            const { data } = await axios.get('/api/workspace-members/job-options')
            return { jobFunctions: data?.jobFunctions ?? [], seniorities: data?.seniorities ?? [] }
        },

        // A prefill for a member's job title, function and seniority: what's saved, then LinkedIn, then
        // AI for the rest. With description (Personal Settings' Autocomplete), their job description too,
        // written by AI from their LinkedIn profile when they have none. Not saved; can take a few seconds
        // when the AI step runs.
        async getJobDetailsSuggestion(_, memberIdOr: number | { memberId: number; description?: boolean }) {
            const { memberId, description } = typeof memberIdOr === 'object' ? memberIdOr : { memberId: memberIdOr, description: false }
            const { data } = await axios.get(`/api/workspace-members/${memberId}/job-details/suggestion`, {
                params: description ? { description: 1 } : undefined,
                cache: false,
                silent: true,
            })
            return data
        },

        async deleteMember(_, { id }) {
            const { data } = await axios.delete(`/api/workspace_members/${id}`)
            return data
        },

        async multiEditMember(_, params) {            
            const { data } = await axios.post(
                '/api/workspace_members/multiedit',
                params,
            )
            return data
        },

        async initMemberSettingsIndex(state: any) {
        	if (this.memberSettingsIndexLoading) {
        		await this.initMemberSettingsPromise
        		return
        	}
            this.memberSettingsIndexLoading = true
            this.initMemberSettingsPromise = this.dispatch('initIndex', {
                id: 'memberSettings',
                idField: 'id',
                indexedFields: [],
                source: '/api/workspace_members',
                store: [
                    '@id',
                    '@type',
                    'autopilot',
                    'commentApprovalsRequired',
                    'contentApprovalsRequired',
                    'contentNotification',
                    'facebookFriendsCount',
                    'id',
                    'logoSocialImageOverlay',
                    'mfaEnabled',
                    'notificationTypePreference',
                    'personalDefaultWebsite',
                    'suggestedContentNotifications',
                    'newCommentAlert',
                    'teamNotifications',
                    'timeZoneAutoUpdate',
                    'unsubEmail',
                    'unsubEmailNewsletter',
                    'unsubscribedAt',
                    'weeklySummaryEmail',
                    'talkingPoints',
                    'customTopics',
                    'distributionQueueDays',
                ],
            })
            await this.initMemberSettingsPromise
            this.memberSettingsIndexLoading = false
            this.initMemberSettingsPromise = null
        },

        async getWorkspaceMemberSettings(_, id) {
            if (id === undefined || id === null) {
                throw new Error(`Invalid member ID specified: ${id}`)
            }
            
            const indexExists = await this.dispatch('indexExists', 'memberSettings')

            if (indexExists) {
                const data = await this.dispatch('getRecord', {
                    index: 'memberSettings',
                    id,
                })
                if(!data) {
                    return await this.dispatch('getWorkspaceMemberSettingsFresh', id)
                }
                return data;
            } else {
                return await this.dispatch('getWorkspaceMemberSettingsFresh', id)
            }
        },

        async getWorkspaceMemberSettingsFresh({ commit, getters }, id) {
            const indexExists = await this.dispatch('indexExists', 'memberSettings')

            const { data } = await axios.get(`/api/workspace_members/${id}/settings`)

            if (!indexExists) {
                await this.dispatch('initMemberSettingsIndex')
            }

            if (data) {
                await this.dispatch('addRecord', {
                    index: 'memberSettings',
                    record: data,
                })
				if (id == getters.authedMemberInfo.id) {
					commit('setAuthedMemberSettings', data)
				}
            }

            return data
        },

        async updateWorkspaceMemberSettings(_, { workspaceMemberId, requestData }) {
            const { data } = await axios.put(
                '/api/workspace_members/' + workspaceMemberId + '/settings',
                requestData,
            )

            return data
        },

        async updateExecutiveFinalApproval(_, { workspaceMemberId, requestData }) {
            const { data } = await axios.put(
                '/api/workspace_members/' + workspaceMemberId + '/executivefinalapproval',
                requestData,
            )

            return data
        },
        
        async getCampaignPreview(_, params) {
 
           let records = null
                        
            const page = 'page=' + (params?.page ?? 1)
            const perPage = params?.perPage ? '&itemPerPage=' + params.perPage : ''
            const status = params?.status ? '&status=' + params.status : ''
            const seatType = params?.seatType ? '&seatType=' + params.seatType : ''            
            const seatTypes = params?.seatTypes ? '&seatTypes=' + params.seatTypes : ''
            const workspaceMemberTags = params?.shareWith ? '&workspaceMemberTags=' + params.shareWith : ''
            const postToNetworks = params?.postToNetworks ? '&postToNetworks=' + params.postToNetworks : ''
            
            const { data } = await axios.get(
                // '/api/workspace_members/campaignpreview?' +
                '/api/workspace_members?' +                
                    page +
                    perPage +
                    status +
                    seatType + 
                    seatTypes +
                    workspaceMemberTags +
                    postToNetworks
            )

            records = {
                items: data['hydra:member'],
                count: data['hydra:totalItems'],
            }

            return records
        },

        async addManager(_, { id, managingId, roles }) {
            const putData = {
                managingId,
                roles,
            }

            const { data } = await axios.put(
                `/api/workspace_members/${id}/addmanager`,
                putData,
            )

            return data
        },

        async removeManager(_, { id, managingId }) {
            const putData = {
                managingId,
            }

            const { data } = await axios.put(
                `/api/workspace_members/${id}/removemanager`,
                putData,
            )

            return data
        },

        // What the data providers returned about a member (Superadmins only): BrightData's payloads for
        // their profiles, and MoltSets
        async getMemberMetaData(_, memberId) {
            const { data } = await axios.get(`/api/workspace-members/${memberId}/meta-data`, { silent: true })
            return data
        },

        // Fetch BrightData: fetch one of the member's profiles from BrightData again (Superadmins only). Returns
        // { message }; the payload shows in the meta data when it arrives
        async fetchMemberBrightData(_, { memberId, profileUuid }: { memberId: number; profileUuid: string }) {
            const { data } = await axios.post(`/api/workspace-members/${memberId}/meta-data/${profileUuid}/fetch`, {}, { silent: true })
            return data
        },

        async addTopic(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/addtopic`, {
                    slug: params.slug
                }
            )
            return data
        },

        async removeTopic(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/removetopic`, {
                    slug: params.slug
                }
            )
            return data
        },

        async addTag(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/addtag`, {
                    slug: params.slug
                }
            )
            return data
        },

        async removeTag(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/removetag`, {
                    slug: params.slug
                }
            )
            return data
        },

        async addToneOfVoice(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/addtoneofvoice`, {
                    slug: params.slug
                }
            )
            return data
        },

        async removeToneOfVoice(_, params) {
            const { data } = await axios.put(
                `/api/workspace_members/${params.id}/removetoneofvoice`, {
                    slug: params.slug
                }
            )
            return data
        },

        async exportMembers(_, params) {
            const search = params?.search ? '&search=' + params.search : ''
            const statusFilter = params?.filters?.status
                ? '&status=' + params.filters.status
                : ''
            const tagFilter = params?.filters?.tag
                ? '&workspaceMemberTag=' + params.filters.tag
                : ''
            const roleFilter = params?.filters?.role
                ? '&role=' + params.filters.role
                : ''
            const fromDateFilter = params?.filters?.fromDate
                ? '&statsDate[from]=' + params.filters.fromDate
                : ''
            const toDateFilter = params?.filters?.toDate
                ? '&statsDate[to]=' + params.filters.toDate
                : ''
            const networkFilter = params?.filters?.network
                ? '&network=' + params.filters.network + '&valid=false'
                : ''
            const sharedContentFilter = params?.filters?.sharedContent
                ? '&sharedContent=' + params.filters.sharedContent
                : ''
            const managersOfFilter = params?.filters?.managersOf
                ? '&managersOf=' + params.filters.managersOf
                : ''
            const seatTypeFilter = params?.filters?.seatType
                ? '&seatType=' + params.filters.seatType
                : ''
            const multipleTagsFilter = params?.filters?.tags?.length > 0
                ? '&workspaceMemberTags=' + params.filters.tags
                : ''
            const memberReport = params?.filters?.memberReport ? '&memberReport=1' : ''
            const sortBy = params?.sortBy ? '&sort=' + params.sortBy : ''
            const sortOrder = params?.sortOrder
                ? '&order=' + params.sortOrder
                : ''

            const { data } = await axios.get(
                '/api/workspace_members/export?' +
                    search +
                    statusFilter +
                    tagFilter +
                    roleFilter +
                    fromDateFilter +
                    toDateFilter +
                    networkFilter +
                    sharedContentFilter +
                    managersOfFilter +
                    seatTypeFilter +
                    multipleTagsFilter +
                    memberReport +
                    sortBy +
                    sortOrder,
            )
            return data
        },

        async setMemberPostCount(_, params) {
            if (params.id === undefined || params.id === null) {
                throw new Error(`Invalid Member ID specified: ${params.id}`)
            }

            const indexExists = await this.dispatch('indexExists', 'member')
            
            if (indexExists) {
                const member = await this.dispatch('getRecord', {
                    index: 'member',
                    id: params.id,
                })
                if (member) {
                    if (params.value) {                        
                        member.postCount = params.value
                    } else {
                        const hasValue = member.postCount !== null && member.postCount !== undefined
                        if (!hasValue) {
                            await axios.get(`/api/posts?page=1&itemPerPage=1&success=true&workspaceMember=${params?.id}&memberType=${params.memberType}`)
                            .then((response) => {
                                member.postCount = response.data['hydra:totalItems']
                            })
                        }
                    }         
                    return member
                } else {
                    throw new Error(`Member not found: ${params.id}`)
                }
            }
        },
        async extensionInstalled(_, { id }) {            
            const { data } = await axios.put(
                `/api/workspace_members/${id}/extension-installed`,
                {
                    install: false,
                },
            )

            return data
        },
    },

    mutations: {
        clearWorkspaceFilters(state: any) {
            state.filters = {}
        },
    },
}

export default teamMemberModule
